import { Alert } from "@mui/material";
import { SectionRow } from "./SectionRow";
import { Indentation } from "./rowTypes";

type Props = Indentation;

export function ProductInventoryStatus({ xWidth, xGap }: Props) {
  return (
    <SectionRow xWidth={xWidth} xGap={xGap}>
      <Alert severity="error">
        This item is currently on backorder. It will ship once it is in stock.
      </Alert>
    </SectionRow>
  );
}
